import { getOptionsFromMappings } from '../utils/getUserMappingOption';
import { useMultiSelectInputContext } from '../contexts';

export const useUserMappingOptions = () => {
  const { userMappings } = useMultiSelectInputContext();

  return getOptionsFromMappings(userMappings);
};
